import "./openModalForSubComANDSmileLight.css";
import "./openModalForSubComANDSmileDark.css";
import RightClickModalForMessageItem from "../rightClickModalForMessageItem/rightClickModalForMessageItem";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SmileForMessageItems from "../smileForMessageItems/smileForMessageItems";
import { editMessage, enabledAll, replyToMessage } from "../../../../redux/reducer/otherMenuOptionsForMessageItems/action/action";
import axios from "axios";
import { getMessageItem } from "../../../../redux/reducer/getMessageItem/action/action";
import { useNavigate, useSearchParams } from "react-router-dom";
import { perexodChatMenu } from "../../../../redux/reducer/perexodChatMenu/actiom/action";
import { getCurrentSubMessageAction } from "../../../../redux/reducer/getCurrentSubMessage/action/action";
import sockets from "../../../../socket/socket";
import { getChatInfoByIDAction } from "../../../../redux/reducer/getChatInfoByID/action/action";
const socket = sockets;

export default function OpenModalForSubComANDSmile({ isOpenModal, setisOpenModal, item, child, index }) {
    const getDarkModoe = useSelector(darkModes => darkModes);
    const isOpenRef = useRef();
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const chatID = searchParams.get('chatID');
    const thread = searchParams.get('thread_message_id');
    const [value, setValue] = useState("");
    const navigate = useNavigate();
    const [chooseWokers, setChooseWokers] = useState([]);
    const gerChekcedCompany = useSelector((allWorkers) => allWorkers);

    useEffect(() => {

        if (isOpenModal) {
            isOpenRef.current.style.display = "flex"
        } else {
            isOpenRef.current.style.display = "none"
        }

    }, [isOpenModal])

    const handleOutsideClick = (event) => {

        // Close the dropdown if the click is outside of it
        if (isOpenRef.current && !isOpenRef.current.contains(event.target)) {
            setisOpenModal(false);
        }
    };

    useEffect(() => {
        // Add event listener to the document to handle outside clicks
        document.addEventListener('click', handleOutsideClick);

        // Clean up the event listener when the component is unmounted
        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, []);
    const addLike = (e) => {
        axios.put('/addLike/api', {
            typeofLike: e,
            item,
            child
        })
            .then(function (response) {
                console.log(response);

                axiosGetWorkers("/getCurrendCompanyWorkers/api");
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    function thread_message(e) {
        e.stopPropagation()
        navigate(`?chatID=${chatID}&thread_message_id=${item._id}`)
        dispatch(perexodChatMenu("checkedChatItem"))
    }
    // useEffect(() => {
    //     function onFooEvent() {
    //         dispatch(getChatInfoByIDAction(`/getChatInfoByID/api?ID=${chatID}`))
    //         if (child == false) {
    //             dispatch(getMessageItem(`/getItemMessages/api?chatID=${chatID}`));

    //         } else {
    //             dispatch(getCurrentSubMessageAction(`/getMessageByID/api?thread=${thread}`))
    //         }
    //     }

    //     if (socket) {
    //         socket.on('updateCreatMessage', onFooEvent);

    //         return () => {
    //             socket.off('updateCreatMessage', onFooEvent);
    //         };
    //     }
    // }, [socket]); // Добавляем socket в зависимости


    // получение идентификатора пользователей этого чата
    function axiosGetWorkers(url) {
        axios
            .get(url)
            .then(function (response) {
                // handle success
                setChooseWokers([]);
                if (response.data.data) {
                    const newChooseWokers = response.data.data.map(item => item.workerID);
                    setChooseWokers(prevWorkers => [...prevWorkers, ...newChooseWokers]);
                    const adminWorkerID = gerChekcedCompany?.rootReducer?.users?.adminInfo?.workerID;
                    if (adminWorkerID) {
                        setChooseWokers(prevWorkers => [...prevWorkers, adminWorkerID]);
                    }

                    if (newChooseWokers.length > 0 || adminWorkerID) {
                        socket.emit("updateCreatMessage", [...newChooseWokers, adminWorkerID]);
                    } else {
                        alert("No workers found");
                    }
                }
            })
            .catch(function (error) {
                // handle error
                console.error("Error fetching data:", error);
            });
    }
    return (
        <div className={getDarkModoe.ToggleDarkModeReducer.chekced ? "openModalForSubComANDSmileDarktCont" : "openModalForSubComANDSmileLightCont"} id={`openModalForSubComANDSmile-${index}`} ref={isOpenRef}>
            <div>
                <div onClick={(e) => addLike(e.target.innerHTML)}>✔️</div>
                <div onClick={(e) => addLike(e.target.innerHTML)}>😀</div>
                <div onClick={(e) => addLike(e.target.innerHTML)}>🙏</div>
                <div onClick={(e) => addLike(e.target.innerHTML)}>👎</div>
                <div onClick={(e) => addLike(e.target.innerHTML)}>👍</div>
                <div >
                    <SmileForMessageItems child={child} setValue={setValue} value={value} addLike={addLike} />
                </div>
                <div onClick={(e) => thread_message(e)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="27" viewBox="0 0 28 27" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M22.6992 0.666667C22.6992 0.298477 22.9977 0 23.3659 0H23.6326C24.0007 0 24.2992 0.298477 24.2992 0.666667V3.20078H26.8333C27.2015 3.20078 27.5 3.49926 27.5 3.86745V4.13411C27.5 4.5023 27.2015 4.80078 26.8333 4.80078H24.2992V7.33333C24.2992 7.70152 24.0007 8 23.6326 8H23.3659C22.9977 8 22.6992 7.70152 22.6992 7.33333V4.80078H20.1667C19.7985 4.80078 19.5 4.5023 19.5 4.13411V3.86745C19.5 3.49926 19.7985 3.20078 20.1667 3.20078H22.6992V0.666667ZM13.5336 6.25H9.46644C8.09472 6.25 7.01929 6.24999 6.15494 6.32061C5.27479 6.39252 4.54769 6.54138 3.88955 6.87671C2.80762 7.42798 1.92798 8.30762 1.37671 9.38955C1.04138 10.0477 0.892522 10.7748 0.820612 11.6549C0.749992 12.5193 0.749995 13.5947 0.75 14.9664V19.2283C0.75 21.7256 2.77441 23.75 5.27166 23.75H5.87341C6.12191 23.75 6.29183 24.001 6.19954 24.2317C5.51288 25.9484 7.4899 27.5003 8.99441 26.4257L11.6051 24.5609L11.6543 24.5259C12.3632 24.0264 13.2079 23.7556 14.0751 23.7501L14.1354 23.75H14.6842L14.8311 23.75H14.8311C16.3797 23.7502 17.3244 23.7504 18.1179 23.5177C19.9971 22.9667 21.4667 21.4971 22.0177 19.6179C22.2504 18.8244 22.2502 17.8798 22.25 16.3312V16.3311L22.25 16.1842V14.9664V14.9664V14.9663V14.9663C22.25 13.5946 22.25 12.5192 22.1794 11.6549C22.1075 10.7748 21.9586 10.0477 21.6233 9.38955C21.072 8.30762 20.1924 7.42798 19.1104 6.87671C18.4523 6.54138 17.7252 6.39252 16.8451 6.32061C15.9807 6.24999 14.9053 6.25 13.5336 6.25ZM4.57054 8.21322C4.98197 8.00359 5.4897 7.87996 6.27708 7.81563C7.07322 7.75058 8.08749 7.75 9.5 7.75H13.5C14.9125 7.75 15.9268 7.75058 16.7229 7.81563C17.5103 7.87996 18.018 8.00359 18.4295 8.21322C19.2291 8.62068 19.8793 9.27085 20.2868 10.0705C20.4964 10.482 20.62 10.9897 20.6844 11.7771C20.7494 12.5732 20.75 13.5875 20.75 15V16.1842C20.75 17.9261 20.7424 18.6363 20.5783 19.1958C20.171 20.5848 19.0848 21.671 17.6958 22.0783C17.1363 22.2424 16.4261 22.25 14.6842 22.25H14.1354L14.0655 22.2501C12.8922 22.2576 11.7493 22.6239 10.7902 23.2997L10.7333 23.3403L8.12255 25.2051C7.83709 25.409 7.46197 25.1145 7.59226 24.7888C8.07867 23.5728 7.18311 22.25 5.87341 22.25H5.27166C3.60284 22.25 2.25 20.8972 2.25 19.2283V15C2.25 13.5875 2.25058 12.5732 2.31563 11.7771C2.37996 10.9897 2.50359 10.482 2.71322 10.0705C3.12068 9.27085 3.77085 8.62068 4.57054 8.21322ZM6.75 13C6.75 12.5858 7.08579 12.25 7.5 12.25H11.5C11.9142 12.25 12.25 12.5858 12.25 13C12.25 13.4142 11.9142 13.75 11.5 13.75H7.5C7.08579 13.75 6.75 13.4142 6.75 13ZM6.75 17C6.75 16.5858 7.08579 16.25 7.5 16.25H15.5C15.9142 16.25 16.25 16.5858 16.25 17C16.25 17.4142 15.9142 17.75 15.5 17.75H7.5C7.08579 17.75 6.75 17.4142 6.75 17Z" fill="#8C9092" />
                    </svg>

                </div>
                <div>
                    <RightClickModalForMessageItem isOpenModal={isOpenModal} item={item} setisOpenModal={setisOpenModal} child={child} index={index} />
                </div>

            </div>
        </div>
    )
}